import React, { useEffect, useState } from "react";
import { Row, Col, Form, Button, Image } from "react-bootstrap";
import "./index.css";
import "./userCompanyInfo.css";
import CustomButton from "../../../common/CustomButton";
import { useSelector, useDispatch } from "react-redux";
import isEmpty from "../../../../utils/is-Empty";
import { capitalize } from "lodash";
import CustomSelectDropdown from "../../../common/CustomSelectDropdown";
import FilterObjectsByKeyValue from "../../../../utils/FilterObjectsByKeyValue";
import { getUserBankingInfo, postUserBankInfo } from "../../../../actions/user.actions";
import PageSpinner from "../../../common/PageSpinner";
import { toast } from "react-toastify";
import { stringConstants } from "../../../../helpers";

const UserBankingInfo = ({ title = "Banking Info", userId }) => {
  const dispatch = useDispatch();
  const [errorMsg, setErrorMsg] = useState("");
  const [loading, setLoading] = useState(false);
  const [isCreateMode, setIsCreateMode] = useState(false);
  const [isUpdateMode, setIsUpdateMode] = useState(false);
  const [uploadFormObj, setUploadFormObj] = useState({});
  const [bankInfo, setBankInfo] = useState({});
  const [showBankInfoEdit, setShowBankInfoEdit] = useState(false);

  const { requestCall, auth } = useSelector((state) => {
    return state;
  });

  useEffect(() => {
    if (!isEmpty(auth) && auth?.loggedIn) {
      if (auth?.user?.role?.role_name === stringConstants.ROLL_BHAREE) {
        setShowBankInfoEdit(false);
      } else {
        setShowBankInfoEdit(true);
      }
    }
  }, [auth]);

  useEffect(() => {
    callGetUserBankInfoAPI(userId, dispatch);
  }, [dispatch, userId]);

  useEffect(() => {
    setIsCreateMode(false);
    setIsUpdateMode(false);
    if (!isEmpty(bankInfo?.data)) {
      setUploadFormObj(bankInfo?.data);
    } else {
      setIsCreateMode(true);
    }
  }, [bankInfo]);

  const callGetUserBankInfoAPI = (mUserId, dispatch) => {
    setLoading(true);
    getUserBankingInfo(mUserId, dispatch)
      .then((res) => {
        setBankInfo(res);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const onSelectValue = (key, value) => {
    let updatedObj = {};
    updatedObj[key] = value;

    setUploadFormObj((previousValues) => ({
      ...previousValues,
      ...updatedObj,
    }));
  };

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile && selectedFile.size > 2 * 1024 * 1024) {
      setErrorMsg("❌ File size must be ≤ 2MB");
      return;
    }
    onSelectValue("cancelled_cheque", selectedFile);
    setErrorMsg("");
  };

  const createUpdateBankingInfo = (e) => {
    e.preventDefault();
    setErrorMsg(null);

    let fileErrors = [];
    if (!uploadFormObj?.cancelled_cheque) {
      fileErrors.push("Please upload a cancelled cheque.");
    }

    if (fileErrors.length > 0) {
      setErrorMsg(fileErrors);
      return;
    }

    if (
      !isEmpty(uploadFormObj) &&
      Object.prototype.hasOwnProperty.call(uploadFormObj, "account_name") &&
      !isEmpty(uploadFormObj.account_name) &&
      Object.prototype.hasOwnProperty.call(uploadFormObj, "account_number") &&
      !isEmpty(uploadFormObj.account_number) &&
      Object.prototype.hasOwnProperty.call(uploadFormObj, "bank_name") &&
      !isEmpty(uploadFormObj.bank_name) &&
      Object.prototype.hasOwnProperty.call(uploadFormObj, "ifsc") &&
      !isEmpty(uploadFormObj.ifsc) &&
      Object.prototype.hasOwnProperty.call(uploadFormObj, "bank_address") &&
      !isEmpty(uploadFormObj.bank_address)
    ) {
      setLoading(true);
      postUserBankInfo(userId, uploadFormObj, dispatch)
        .then((res) => {
          if (res.success) {
            toast.success(res.message);
            setIsUpdateMode(false);
            setIsCreateMode(false);
            callGetUserBankInfoAPI(userId, dispatch);
          }
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      setErrorMsg("Please enter the mandatory fields.");
    }
  };

  const bankInfoForm = () => {
    return (
      <Row className="m-0 form-row ">
        <Row className="m-0 px-0 w-full px-0 mb-4 title-button-row">
          <Col md={6} xs={6} className="m-0 p-0">
            <h2>{!isUpdateMode ? "ADD Bank details" : "Update Bank details"}</h2>
          </Col>
          <Col md={6} xs={6} className="m-0 p-0 text-end">
            {bankInfo?.data !== null && (
              <Button
                className="btn-theme"
                size="sm"
                onClick={() => {
                  setIsCreateMode(false);
                  setIsUpdateMode(false);
                }}
              >
                <i className="bi bi-eye"></i> {"View"}
              </Button>
            )}
          </Col>
        </Row>
        <Form className="my-2 modal-custom-class" onSubmit={createUpdateBankingInfo}>
          <Row className="m-0 ">
            <Col xs={12} md={6}>
              <Form.Group className="mb-3" controlId="formBasicEmail">
                <Form.Label>
                  {"Account Name"}
                  <span className="redStreSpan">{"*"}</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  required
                  value={uploadFormObj?.account_name}
                  onChange={(e) => onSelectValue("account_name", e.target.value)}
                />
              </Form.Group>
            </Col>
            <Col xs={12} md={6}>
              <Form.Group className="mb-3" controlId="formBasicEmail">
                <Form.Label>
                  {"Account Number"}
                  <span className="redStreSpan">{"*"}</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  required
                  value={uploadFormObj?.account_number}
                  onChange={(e) => onSelectValue("account_number", e.target.value)}
                />
              </Form.Group>
            </Col>

            <Col xs={12} md={6}>
              <Form.Group className="mb-3" controlId="formBasicEmail">
                <Form.Label>
                  {"Bank Name"}
                  <span className="redStreSpan">{"*"}</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  required
                  value={uploadFormObj?.bank_name}
                  onChange={(e) => onSelectValue("bank_name", e.target.value)}
                />
              </Form.Group>
            </Col>
            <Col xs={12} md={6}>
              <Form.Group className="mb-3" controlId="formBasicEmail">
                <Form.Label>
                  {"IFSC"}
                  <span className="redStreSpan">{"*"}</span>
                </Form.Label>

                <Form.Control
                  type="text"
                  required
                  value={uploadFormObj?.ifsc}
                  onChange={(e) => onSelectValue("ifsc", e.target.value)}
                />
              </Form.Group>
            </Col>
            <Col xs={12} md={6}>
              <Form.Group className="mb-3" controlId="formBasicEmail">
                <Form.Label>
                  {"Bank Address"}
                  <span className="redStreSpan">{"*"}</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  required
                  value={uploadFormObj?.bank_address}
                  onChange={(e) => onSelectValue("bank_address", e.target.value)}
                />
              </Form.Group>
            </Col>
            <Col xs={12} md={6}>
              <Form.Group controlId="formFile" className="mb-3">
                <Form.Label>
                  Upload Cancelled Cheque (PNG/JPG/PDF ≤ 2MB)
                  <span className="redStreSpan">{"*"}</span>
                  {(() => {
                    if (bankInfo?.data?.cancelled_cheque) {
                      return (
                        <Image
                          className="img-fluid px-0 mx-0 mt-2"
                          src={bankInfo?.data?.cancelled_cheque}
                          alt="Cancelled Cheque"
                          style={{ width: "300px" }}
                        />
                      );
                    }
                  })()}
                </Form.Label>
                <Form.Control
                  type="file"
                  accept="image/*,application/pdf"
                  onChange={handleFileChange}
                  className="custom-file-input"
                />
              </Form.Group>
            </Col>
          </Row>

          {errorMsg && <p className="error-msg">{errorMsg}</p>}
          <div className="action-buttons">
            {bankInfo?.data !== null && (
              <CustomButton
                buttonClasses="close-btn"
                onClick={() => setIsCreateMode(false)}
                disabled={requestCall?.loading}
              >
                <i className="bi bi-x-lg"></i> {"Close"}
              </CustomButton>
            )}

            <CustomButton
              variant="primary"
              buttonClasses={!requestCall?.loading ? "submit-btn" : "submit-btn-loading"}
              type="submit"
              loading={requestCall?.loading}
            >
              <i className="bi bi-floppy"></i> {!isUpdateMode ? "Add" : "update"}
            </CustomButton>
          </div>
        </Form>
      </Row>
    );
  };

  const bankInfoView = () => {
    return (
      <Row className="bankInfo m-0">
        <Row className="heading-div">
          <Col md={6} xs={6} className="m-0 p-0">
            <h5 className="text-uppercase p-0 m-0">Bank Details</h5>
          </Col>
          {showBankInfoEdit && (
            <Col md={6} xs={6} className="m-0 p-0 text-end">
              <Button
                className="btn-theme"
                size="sm"
                onClick={() => {
                  setIsUpdateMode(true);
                }}
              >
                <i className="bi bi-pencil"></i> Edit
              </Button>
            </Col>
          )}
        </Row>
        <hr />
        <Row className="m-0 p-0">
          <Col xs={12} md={6} lg={4} className="p-0">
            <p>
              <span>{"Account Name:"}</span>
              <span className="mx-2 bold-span"> {bankInfo?.data?.account_name}</span>
            </p>
          </Col>
          <Col xs={12} md={6} lg={4} className="p-0">
            <p>
              <span>{"Bank Name:"}</span>
              <span className="mx-2 bold-span"> {bankInfo?.data?.bank_name}</span>
            </p>
          </Col>
          <Col xs={12} md={6} lg={4} className="p-0">
            <p>
              <span>{"Bank Address:"}</span>
              <span className="mx-2 bold-span"> {bankInfo?.data?.bank_address}</span>
            </p>
          </Col>
          <Col xs={12} md={6} lg={4} className="p-0">
            <p>
              <span>{"Account Number:"}</span>
              <span className="mx-2 bold-span"> {bankInfo?.data?.account_number}</span>
            </p>
          </Col>
          <Col xs={12} md={6} lg={4} className="p-0">
            <p>
              <span>{"IFSC:"}</span>
              <span className="mx-2 bold-span"> {bankInfo?.data?.ifsc}</span>
            </p>
          </Col>
        </Row>
        <Row className="m-0 p-0">
          <h5 className="text-uppercase p-0 m-0 mt-3 small">Cancelled Cheque</h5>
          {(() => {
            if (bankInfo?.data?.cancelled_cheque) {
              return (
                <Image
                  className="img-fluid px-0 mx-0 mt-2"
                  src={bankInfo?.data?.cancelled_cheque}
                  alt="Cancelled Cheque"
                  style={{ width: "300px" }}
                />
              );
            } else {
              return (
                <p className="text-danger small px-0 mt-2 m-0">
                  Please upload cancelled cheque by clicking on the "Edit" button.
                </p>
              );
            }
          })()}
        </Row>
      </Row>
    );
  };

  return (
    <>
      {loading && <PageSpinner />}
      <div className="p-0 company-info-container">
        {(() => {
          if (!isEmpty(bankInfo?.data)) {
            if (!isUpdateMode) {
              return bankInfoView();
            } else {
              return bankInfoForm();
            }
          }
        })()}
      </div>
    </>
  );
};

export default UserBankingInfo;
